import { AxiosError } from 'axios';

export const throwException = (error: Error) => {
  throw error;
};

interface ServiceError {
  statusCode?: number;
  data?: unknown;
}

export const logAxiosError = (errorMessage: string, error: AxiosError) => {
  let errorObject: ServiceError = {};
  if (error.response) {
    errorObject.statusCode = error.response.status;
    if (error.response.data) {
      errorObject.data = error.response.data;
    }
  }
  console.error(errorMessage, error);
};
